export default "/images/thumb-search-hint.png?d6a8d3ae26ca0323a7b22b1893357da7";